define('views/pages/GuiPageView',['underscore','jquery','PageView','app'],function(_,$,PageView,app){

    return PageView.extend({
        pageName:'Gui',
        events: {
            'click .alert-modal-btn': 'alertModal',
            'click .confirm-modal-btn': 'confirmModal',
            'click .bottom-notice-btn': 'bottomNotice',
            'click .ban-notice-btn': 'banNotice'
        },

        initialize:function(){

            var view = this;

            // PageView constructor heritage
            PageView.prototype.initialize.apply(view,arguments);
            //

            var playing = true;
            view.$('.stopClock').click(function(){
                playing = !playing;
                if(playing){
                    view.$('.clock-animate').addClass('loading');
                }
            });
            view.$(".clock-animate .needle-s").on('animationiteration webkitAnimationIteration', function(e) {
                if(!playing){
                    view.$(".clock-animate").removeClass('loading');
                }
            });

        },

        alertModal: function(){
            app.alert({title: 'test title', subtitle:'test subtitle'});
        },

        confirmModal: function(){
            app.confirm({title: 'test title', subtitle:'test subtitle'}, function(val){
            });
        },

        bottomNotice: function(){
            app.bottomNotice('test notice');
        },

        banNotice: function(){
            app.banNotice('test notice');
        }

    });

});
